/**
 * 功能:图片惰性加载。在需要图片惰性加载的页面底部载入。再将图片加上class=“lazy”。并将图片的真实地址放置在图片的自定义属性dataimg中。
 * @author haunghm
 * @version 1.0.0
 * @dependencies jquery 或者 zepto
 * @update wuwl #### 20150424 for 去除ios判定
 * 默认图CDN地址：
 * 小图：//image.9game.cn/s/uae/g/0h/portal/image/lazy.gif
 * 大图：//image.9game.cn/s/uae/g/0h/portal/image/lazy2.gif
 *
 * @method setInit(ListenDOM) <String(DOMQuerySelector)> ListenDOM 自定义监听指定DOM的滚动情况
 */

const lazyLoad = {
  init(ListenDOM) {
    const that = this;
    that.img.srcStore = 'dataimg'; // 图片真实地址存放的自定义属性
    that.img.class = 'lazy'; // 惰性加载的图片需要添加的class
    that.img.sensitivity = 50; // 该值越小，惰性越强（加载越少）
    that.img.init(ListenDOM);
  },
  img: {
    trigger(ListenDOM) {
      const that = this;
      const eventType = (that.isPhone && 'touchend') || 'scroll';
      that.imglist = $('img.' + that.class + '');
      $(ListenDOM || window).trigger(eventType);
    },
    init(ListenDOM) {
      let that = this;
        // minScroll = 5,
        // slowScrollTime = 200;

      $(ListenDOM||window).on('scroll', function() {
        that.changeimg();
      });

      that.trigger(ListenDOM);
      that.isload = !0;
    },
    changeimg() {
      const that = this;

      function loadYesOrno(img) {
        const windowPageYOffset = window.pageYOffset;
        const windowPageYOffsetAddHeight = window.pageYOffset + window.innerHeight;
        const imgOffsetTop = img.offset().top;
        return (
          imgOffsetTop >= windowPageYOffset &&
          imgOffsetTop - that.sensitivity <= windowPageYOffsetAddHeight
        );
      }

      function loadImg(img, index) {
        const imgUrl = img.attr(that.srcStore);
        const imgLazy = img.attr('src');
        img.attr('src', imgUrl);
        img[0].onload ||
          ((img[0].onload = function() {
            $(this)
              .removeClass(that.class)
              .removeAttr(that.srcStore),
            (that.imglist[index] = null),
            (this.onerror = this.onload = null);
          }),
            (img[0].onerror = function() {
              (this.src = imgLazy),
              $(this)
                .removeClass(that.class)
                .removeAttr(that.srcStore),
              (that.imglist[index] = null),
              (this.onerror = this.onload = null);
            }));
      }

      that.imglist.each(function(index, val) {
        if (!val) return;
        const img = $(val);
        if (!loadYesOrno(img)) return;
        if (img.height() == 0 && img.width() == 0) return; // 针对被display:none的元素中的图片处理。目前场景主要在专区里
        const aa = img.attr(that.srcStore);
        if (!img.attr(that.srcStore)) return;
        loadImg(img, index);
      });
      // that.trigger();
    },
  },
  forceUpdate() {
    lazyLoad.img.trigger();
    lazyLoad.img.changeimg();
  },
};
lazyLoad.init();

module.exports = {
  setInit(ListenDOM) {
    lazyLoad.init(ListenDOM);
  },
  // 提供一个可以强制触发懒加载更新的方法
  forceUpdate: lazyLoad.forceUpdate,
};



// WEBPACK FOOTER //
// ./lib/js/public/lazyload.js